import { axiosRequest } from '../middlewares/axios'
import {conf} from '../config/config'

export const scenarioService = {
  get
}

async function get({ params } : { params:any }) {
  return await axiosRequest.putRequest(conf.API_URL + '/scenario/' + params.customerId, params)
}